export enum ViewModelType {
  LIST = "list",
  DETAIL = "detail",
  CONFIG = "config", // i.e. spanner menu
}
